module.exports = __webpack_public_path__ + "static/media/08-07-2023-Lindsay-Sever-Photography-320.beb5460e.jpg";